import { IconType } from "react-icons/lib";
import { RiArrowUpSLine } from "react-icons/ri";

import { cn } from "~/utils/fontsConfig";

type Props = {
    isSelected: boolean;
    Icon: IconType;
    children: React.ReactNode;
    toggleChildren: () => void;
    isOpen: boolean | Map<string, boolean> | undefined;
};

export const NavTitleWrapper = ({
    isSelected,
    Icon,
    children,
    toggleChildren,
    isOpen,
}: Props) => {
    return (
        <div
            className={cn(
                "grid cursor-pointer select-none grid-cols-[16%_84%] items-center justify-center rounded-lg px-4 py-2 text-white hover:bg-v3-N-400",
                {
                    "bg-v3-N-400": isSelected,
                },
            )}
            onClick={toggleChildren}
        >
            <Icon className="text-lg" />
            <div className="flex items-center justify-between">
                <span>{children}</span>
                <div
                    className={cn(
                        "transform cursor-pointer transition-transform duration-300 ease-in-out",
                        {
                            "rotate-180": isOpen,
                            "rotate-0": !isOpen,
                        },
                    )}
                >
                    <RiArrowUpSLine className="text-xl" />
                </div>
            </div>
        </div>
    );
};
